import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState'; 
import ModulesState from './Modules.State'; 
import ModulesAction from './Modules.Action';
import {CompanySelection} from 'kts-platform-frame/display/part';  
import { MyStore, reducers } from 'kts-platform-frame/redux';

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */ 
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }  

    onchange = (values) => { 
        this.hide();
    } 
    render() {   
        return (
            <div> 
                <CompanySelection 
                    // showSearch={false} 
                    // isCheck={false} 
                    request={ModulesAction.pageListUsersListTest}
                    onSubmitCompany={this.onchange} 
                    defaultValue={['bb15da22-b890-4ceb-b830-d42c3676a855']} 
                />  
            </div>
        );
    }   
    private hide = () => {   
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.removeHide, null);
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.test.tsx